import "./LayoutStyle.scss"
import React, {useContext, useMemo, useState} from "react";
import {Layout} from "antd";
import Navbar from "./navbar/Navbar";
import Navigator from "./navbar/Navigator";
import {GlobalContext} from "@tools/globalContext";
import {useEventEmitter} from "@hooks/useEventEmitter";
import {EEmitterEventName} from "@tools/CustomInterfaces";
import clone from "@tools/clone";

interface Props {
    children: any
}

const DefaultLayout: React.FC<Props> = (props) => {
    const { sideBarCollapsed } = useContext(GlobalContext);
    const [styles, setStyles] = useState()
    const {useListener } = useEventEmitter()

    useListener(EEmitterEventName.layoutStyleChange , styles => {
        setStyles({...styles})
    })

    const sideBarClass = useMemo(() => {
        if(sideBarCollapsed === "none") 
            return "noSideBar"
        else if(sideBarCollapsed)
            return "collapsed"
        return ""
    }, [sideBarCollapsed])

    return <>
        <Navbar />
        <Layout className="contentContainer">
            <Navigator />
            <div className={`siteContent ${sideBarClass}`} style={styles}>
                {props.children}
            </div>
        </Layout>
    </>
}

export default DefaultLayout
